const MEDIA_PUBLIC_BASE = "https://media.bonggo.app/public";

export function toPublicMediaUrl(audioUrlOrKey?: string | null) {
  if (!audioUrlOrKey) return "";

  const v = audioUrlOrKey.trim();

  // already full URL
  if (v.startsWith("http://") || v.startsWith("https://")) return v;

  // remove leading slash like "/audio/..."
  const key = v.replace(/^\/+/, "");
  // Normalize keys accidentally stored as "public/..." in Mongo.
  const normalizedKey = key.replace(/^public\/+/, "");

  return `${MEDIA_PUBLIC_BASE}/${normalizedKey}`;
}
